module.exports = __webpack_public_path__ + "img/Feature.8c9a2cc3.jpg";